module.exports = __webpack_public_path__ + "media/images/emblems/Kallnach-coat_of_arms-fd8433e8bee18826960ae0fd0ebda927.svg";